import { getLanguage } from "../utils";
import i18n from "./i18n";

const locale = getLanguage();
i18n.load(locale, window.appSettings.translations);
